import { cowFeed, huggingMachine } from './items.js'

const inventory = [cowFeed, huggingMachine]

export default inventory
